module.exports = __webpack_public_path__ + "static/media/Artboard_2.3aea8346.jpg";